import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Page from './../models/Page';


export function getPages(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_LIST,
        params: params,
        parser: pagesDataParser,
    }).get();
}

export function getPageDetail(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_DETAIL,
        endpointParams: { id },
        parser: (data) => new Page(data.data),
    }).get();
}

export function createPageDetail(page) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_ACTION,
        parser: (data) => new Page(data.page),
    }).post(page.export());
}

export function updatePageDetail(page) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_ACTION,
        // endpointParams: { id: page.id },
        parser: (data) => new Page(data.page),
    }).put(page.export());
}

export function deletePageDetail(page) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_DETAIL,
        endpointParams: { id: page.id },
        // parser: (data) => new Page(data.page),
    }).delete();
}

export function createPageTranslate(page) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_TRANSLATE_CREATE,
    }).post(page.export(true).translate());
}

export function updatePageTranslate(page) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_TRANSLATE_UPDATE,
    }).put(page.export(true).translate());
}

export function deletePageTranslate(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.PAGE_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const pagesDataParser = (data) => ({
    pages: (data.data.result || []).map(item => new Page(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
});

// const getHotelItem = (i) => new Page({
//     id: i,
//     name: 'Hotel name ' + (i + 1),
//     code: `CODE${i}`,
//     shortDescription: `Short Description ${i + 1}`,
//     description: `Description ${i + 1}`,
//     types: [(i % 4 == 0 ? HOTEL.TYPE.VILLA : i % 3 == 0 ? HOTEL.TYPE.CONDOTEL : i % 2 == 0 ? HOTEL.TYPE.RESORT : HOTEL.TYPE.APARTMENT)],
//     address: `Address ${i + 1}`,
//     province: 'Province 1',
//     country: 'Việt Nam',
//     locationId: i,
//     lat: 10.7797855,
//     lng: 106.6990189,
//     star: i % 5 + 1,
//     hotline: `09231443 ${i + 1}`,
//     review: i + 10,
//     refId: i,
//     media: [{ url: 'placeimg.com/200/200/any', order: 0 }],
//     isActive: i % 2 == 0,
// });
//
// const getDummyPages = (pageSize = 10, pageIndex = 1) => {
//     const result = getDummyData(pageSize, pageIndex, getHotelItem);
//     return { ...result, hotels: result.data };
// }

